import React from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from "primereact/column";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {RadioButton} from "primereact/radiobutton";
import NumberFormat from "react-number-format";
import {amount, amountDataTableTemplate} from "../../../utils/formatters/Numbers";
import {Dropdown} from "primereact/dropdown";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import LinearProgress from "@material-ui/core/LinearProgress";
import Divider from "@material-ui/core/Divider";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const AmountOperation = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <div>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    <Grid container spacing={1}>
                        {props.messagesGrowl}

                        {localStorage.getItem('institution') === 'Interno' ?
                            <Grid item xs={12}>
                                <HeaderScreenPresval
                                    headerTitle="Operación \ Valores Disponibles PTM \ Montos de Operación"
                                    onExpand={props.clearFilters}
                                    actionSearch={props.getAmountOperation}>
                                    <div className="p-grid">
                                        <div className="p-col-12 p-md-6 p-col-6">
                                            <SubtitleLabel header="Institución Prestamista" isBold={true}/>
                                            <Dropdown name="catInstitutionBorrowerFilter"
                                                      options={props.institutionList}
                                                      filterBy="nombreCorto"
                                                      optionLabel="nombreCorto"
                                                      placeholder="Seleccione..."
                                                      onChange={props.saveFilters}
                                                      value={props.catInstitutionBorrowerFilter}/>
                                        </div>
                                        <div className="p-col-12 p-md-6 p-col-6">
                                            <br/>
                                            <Button label="Limpiar"
                                                    style={{'float': 'right'}}
                                                    onClick={props.clearFilters}
                                                    className="p-button-secondary"/>
                                        </div>
                                    </div>
                                </HeaderScreenPresval>
                            </Grid> :
                            <Grid container spacing={1}>
                                <Grid item xs={10}>
                                    <TitlePage title={"Control de Límite \\ Montos de Operación"}/>
                                </Grid>
                                <Grid item xs={2}>
                                    <Button label="Buscar" style={{'float': 'right'}}
                                            onClick={props.getAmountOperation}/>
                                </Grid>
                                <Grid item xs={12}><Divider/></Grid>
                            </Grid>}

                        <Grid item xs={12}>
                            <div className="content-section implementation">
                                {
                                    localStorage.getItem('institution') !== 'Interno' &&
                                    <DataTable header={props.headerOperationAmount}
                                               value={props.amountOperationList}
                                               responsive={true}
                                               resizableColumns={true}
                                               columnResizeMode={"fit"}
                                               selectionMode={"single"}
                                               selection={props.amountOperationSelectedTab}
                                               onSelectionChange={props.onSelectionChangeTable}>
                                        <Column field="razonSocial" header="Institución"
                                                style={{textAlign: 'left'}} sortable={true}/>
                                        <Column field="opera" header="Opera"
                                                style={{textAlign: 'left'}}
                                                sortable={true}
                                                body={(rowData) => (rowData && rowData['opera'] === '1') ?
                                                    "Sí" : "No"}/>
                                        <Column field="lineaEstablecida" header="Línea Establecida"
                                                style={{textAlign: 'right'}}
                                                body={amountDataTableTemplate} sortable={true}/>
                                        <Column field="montoUtilizado" header="Monto Utilizado"
                                                style={{textAlign: 'right'}}
                                                body={amountDataTableTemplate} sortable={true}/>
                                        <Column field="montoDisponible" header="Monto Disponible"
                                                style={{textAlign: 'right'}} sortable={true}
                                                body={amountDataTableTemplate}/>
                                        <Column header="Acciones" body={props.amountOrderActionTemplate}
                                                style={{textAlign: 'center', width: '8em'}}/>
                                    </DataTable>
                                }
                                {
                                    localStorage.getItem('institution') === 'Interno' &&
                                    <DataTable header={props.headerOperationAmount}
                                               value={props.amountOperationList}
                                               responsive={true}
                                               resizableColumns={true}
                                               columnResizeMode={"fit"}>
                                        <Column field="razonSocial" header="Institución"
                                                style={{textAlign: 'left'}} sortable={true}/>
                                        <Column field="opera" header="Opera"
                                                style={{textAlign: 'left'}}
                                                sortable={true}
                                                body={(rowData) => (rowData && rowData['opera'] === '1') ?
                                                    "Sí" : "No"}/>
                                        <Column field="lineaEstablecida" header="Línea Establecida"
                                                style={{textAlign: 'right'}}
                                                sortable={true}
                                                body={amountDataTableTemplate}/>
                                        <Column field="montoUtilizado" header="Monto Utilizado"
                                                style={{textAlign: 'right'}}
                                                sortable={true}
                                                body={amountDataTableTemplate}/>
                                        <Column field="montoDisponible" header="Monto Disponible"
                                                style={{textAlign: 'right'}}
                                                sortable={true}
                                                body={amountDataTableTemplate}/>
                                    </DataTable>
                                }
                            </div>
                        </Grid>
                    </Grid>
                </Paper>

                <Dialog visible={props.displayDialog} header={props.dialogHeader} modal={true}
                        onHide={props.onHideDialog} closable={false}>
                    {
                        props.amountOperationSelected.idInstitucionPTT &&

                        <div className="p-grid p-fluid">
                            <div className="p-col-4">
                                <SubtitleLabel header={"Institución Seleccionada:"}/>
                            </div>
                            <div className="p-col-8">
                                <SubtitleLabel header={ props.amountOperationSelected.razonSocial} isBold={true}/>
                            </div>
                            <div className="p-col-3">
                                <SubtitleLabel header={"Monto Utilizado:"}/>
                            </div>
                            <div className="p-col-9">
                                <SubtitleLabel header={amount(props.amountOperationSelected.montoUtilizado)} isBold={true}/>
                            </div>
                            <div className="p-col-6">
                                <SubtitleLabel header="Opera" isBold={true}/>
                                <RadioButton
                                    inputId="yes"
                                    name="yes"
                                    value="yes"
                                    checked={props.amountOperationSelected.opera === "1"}
                                    onChange={props.saveRadioButtonOption}/>
                                <label htmlFor="yes" className="p-radiobutton-label">Si</label>
                                &nbsp;
                                <RadioButton
                                    inputId="no"
                                    name="no"
                                    value="no"
                                    checked={props.amountOperationSelected.opera === "0"}
                                    onChange={props.saveRadioButtonOption}/>
                                <label htmlFor="no" className="p-radiobutton-label">No</label>
                            </div>
                            <div className="p-col-6">
                                <SubtitleLabel header="Línea Establecida" isBold={true}/>
                                <NumberFormat
                                    name="lineaEstablecida"
                                    allowNegative={false}
                                    maxLength={15}
                                    className={"p-inputtext p-component p-filled"}
                                    value={props.amountOperationSelected.lineaEstablecida}
                                    thousandSeparator={true}
                                    onChange={props.saveData}
                                    placeholder={"Ex: 1,000,000.00"}
                                />
                            </div>
                        </div>
                    }
                </Dialog>
            </div>
        </React.Fragment>
    )
};

export default AmountOperation;
